import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EscaloneLoading from '../EscaloneLoading';

/**
 * Componente que redireciona para a tarefa pelo ID
 * Rota: /t/:taskId
 * 
 * Se o usuário está logado, salva no sessionStorage e redireciona para abrir a tarefa.
 * Se não está logado, redireciona para login com retorno programado.
 */
const TaskRedirect = () => {
  const { taskId } = useParams<{ taskId: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!taskId) {
      setError('ID da tarefa não fornecido');
      setLoading(false);
      return;
    }

    console.log('🔍 Abrindo tarefa pelo link:', taskId);

    // Verificar se há sessão
    const sessionStr = localStorage.getItem('session');
    const session = sessionStr ? JSON.parse(sessionStr) : null;

    if (session?.usuario) {
      // Usuário logado - salvar taskId e redirecionar
      sessionStorage.setItem('pendingTaskOpen', taskId);
      navigate('/', { replace: true });
    } else {
      // Usuário não logado - salvar para depois e ir para login
      sessionStorage.setItem('redirectAfterLogin', JSON.stringify({
        type: 'task',
        taskId
      }));
      navigate('/login', { replace: true });
    }
  }, [taskId, navigate]);

  if (loading && !error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-white to-purple-50">
        <div className="text-center">
          <EscaloneLoading />
          <p className="mt-4 text-gray-600">Abrindo tarefa...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-white to-purple-50">
        <div className="text-center max-w-md p-8">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-xl font-bold text-gray-900 mb-2">Tarefa não encontrada</h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
          >
            Ir para Home
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default TaskRedirect;
